import { DraftInitInfoDto, OrderType } from '@onrunning/backstage-models';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNewRelic } from '../composables/useNewRelic';
import { useNotification } from '../composables/useNotification';
import { DraftsService } from '../services/drafts.service';

export const useDraftsInitInfoStore = defineStore('drafts-init-info', () => {
  const initInfo = ref<DraftInitInfoDto | undefined>();
  const draftsService = new DraftsService();
  const newrelic = useNewRelic();
  const { notifyError } = useNotification();
  const { t } = useI18n();

  async function getInitialInfoData(accountId: string) {
    if (initInfo.value) {
      return initInfo.value;
    } else {
      const response = await draftsService.getInitInfo(accountId);
      if (response.isValid() && response.model) {
        initInfo.value = response.model;

        return initInfo.value;
      } else if (response.statusCode !== 401) {
        newrelic.noticeError('GlobalStore#getInitialInfoData Failed to fetch initial information', {
          accountNumber: accountId,
          component: 'global-store',
          method: 'getInitData',
        });
        notifyError(t('global.init_info_missing'));
      }

      return new DraftInitInfoDto();
    }
  }

  const currentSeason = computed(() => {
    if (initInfo.value) {
      const orderTypeDto = initInfo.value?.orderTypes?.find((ot) =>
        [OrderType.MultiplePreOrder, OrderType.PreOrder].includes(ot.type),
      );
      if (orderTypeDto) {
        return orderTypeDto.preOrderSeasonName;
      }
    }

    return undefined;
  });

  function resetInitInfoData() {
    initInfo.value = undefined;
  }

  return {
    getInitialInfoData,
    resetInitInfoData,
    initInfo,
    currentSeason,
  };
});
